import { createContext, useContext, useState, type ReactNode } from 'react';
import type { CheckoutState, PaymentMethod, PaymentStatus } from '../types';

interface PaymentContextType {
  checkout: CheckoutState;
  status: PaymentStatus;
  error: string | null;
  clientSecret: string | null; // ADDED FOR REAL PAYMENT
  subscriptionId: string | null; // ADDED FOR REAL PAYMENT
  setStatus: (s: PaymentStatus) => void;
  setError: (e: string | null) => void;
  setClientSecret: (s: string | null) => void; // ADDED FOR REAL PAYMENT
  setSubscriptionId: (s: string | null) => void; // ADDED FOR REAL PAYMENT
  setOccupation: (id: string) => void;
  setPlan: (id: string) => void;
  setInterval: (i: 'monthly' | 'annual') => void; // ADDED FOR REAL PAYMENT
  setPriceId: (id: string) => void; // ADDED FOR REAL PAYMENT
  setPaymentMethod: (m: PaymentMethod) => void;
  setFreeTrial: (v: boolean) => void;
  reset: () => void;
}

const initialCheckout: CheckoutState = { freeTrial: false };

const PaymentContext = createContext<PaymentContextType | undefined>(undefined);

export function PaymentProvider({ children }: { children: ReactNode }) {
  const [checkout, setCheckout] = useState<CheckoutState>(initialCheckout);
  const [status, setStatus] = useState<PaymentStatus>('idle');
  const [error, setError] = useState<string | null>(null);
  const [clientSecret, setClientSecret] = useState<string | null>(null); // ADDED FOR REAL PAYMENT
  const [subscriptionId, setSubscriptionId] = useState<string | null>(null); // ADDED FOR REAL PAYMENT

  const value: PaymentContextType = {
    checkout,
    status,
    error,
    clientSecret,
    subscriptionId,
    setStatus,
    setError,
    setClientSecret,
    setSubscriptionId,
    setOccupation: (occupationId) => setCheckout((c) => ({ ...c, occupationId })),
    setPlan: (planId) => setCheckout((c) => ({ ...c, planId })),
    setInterval: (interval) => setCheckout((c) => ({ ...c, interval })),
    setPriceId: (priceId) => setCheckout((c) => ({ ...c, priceId })),
    setPaymentMethod: (paymentMethod) => setCheckout((c) => ({ ...c, paymentMethod })),
    setFreeTrial: (freeTrial) => setCheckout((c) => ({ ...c, freeTrial })),
    reset: () => {
      setCheckout(initialCheckout);
      setStatus('idle');
      setError(null);
      setClientSecret(null);
      setSubscriptionId(null);
    },
  };

  return <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>;
}

export function usePaymentContext() {
  const context = useContext(PaymentContext);
  if (context === undefined) {
    throw new Error('usePaymentContext must be used within a PaymentProvider');
  }
  return context;
}
